export default __webpack_public_path__ + "static/multiple-leaf-nogap-120b7423d0949a61ef42f1b4fb84e4c4.png";